export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FamiliarPage.vue?vue&type=template&id=77422529&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/FamiliarPage.vue?vue&type=template&id=77422529&scoped=true&
// module id = 602
// module chunks = 13